var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup4419(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.753,
    height: 28.123,
    viewBox: "0 0 23.753 28.123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4419",
    "data-name": "Group 4419",
    transform: "translate(-432.593 -5957.149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Document-2",
    d: "M14.157,14.2H6.906a.6.6,0,0,0-.444.172.575.575,0,0,0-.173.424.607.607,0,0,0,.173.44.592.592,0,0,0,.444.178h7.25a.608.608,0,0,0,.617-.618.567.567,0,0,0-.178-.424A.606.606,0,0,0,14.157,14.2Zm0,3.329H6.906a.592.592,0,0,0-.444.178.607.607,0,0,0-.173.44.577.577,0,0,0,.173.424.6.6,0,0,0,.444.173h7.25a.605.605,0,0,0,.439-.173.569.569,0,0,0,.178-.424.608.608,0,0,0-.617-.618ZM5.45,23.378H15.82a3.125,3.125,0,0,0,2.319-.786,3.2,3.2,0,0,0,.777-2.339V11.407a7.156,7.156,0,0,0-.073-1.109,2.477,2.477,0,0,0-.28-.825,3.847,3.847,0,0,0-.618-.789L12.7,3.358a3.038,3.038,0,0,0-1.152-.788,4.56,4.56,0,0,0-1.44-.192H5.45a3.117,3.117,0,0,0-2.315.791,3.2,3.2,0,0,0-.782,2.343V20.253a3.185,3.185,0,0,0,.782,2.339A3.128,3.128,0,0,0,5.45,23.378Zm.117-1.749a1.455,1.455,0,0,1-1.09-.375,1.487,1.487,0,0,1-.364-1.08V5.591a1.479,1.479,0,0,1,.369-1.075,1.46,1.46,0,0,1,1.1-.38H9.814V9.622a2,2,0,0,0,.488,1.473,1.987,1.987,0,0,0,1.463.488h5.4v8.591a1.307,1.307,0,0,1-1.473,1.455ZM11.954,10a.482.482,0,0,1-.561-.561V4.416L16.887,10Z",
    transform: "translate(430.239 5954.771)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4418",
    "data-name": "Group 4418",
    transform: "translate(440.04 5968.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M332.407,260.989a8.153,8.153,0,1,1-8.153-8.153,8.153,8.153,0,0,1,8.153,8.153",
    transform: "translate(-316.102 -252.836)",
    fill: "#95a7c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M398.507,327.5h-2.663v-3a.646.646,0,1,0-1.286,0v3h-2.663a.71.71,0,0,0,0,1.413h2.663v2.859a.646.646,0,1,0,1.286,0v-2.859h2.663a.71.71,0,0,0,0-1.413",
    transform: "translate(-386.812 -319.991)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup4419);
export default __webpack_public_path__ + "static/media/Group 4419.af9fcf963ba597d0ecdc2bf99443d3d2.svg";
export { ForwardRef as ReactComponent };